import Vue from "vue";
import axios from "axios";

let cancelTokenSource = null;

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
});

// Add a method to cancel ongoing requests
axiosIns.cancelOngoingRequests = (excludeUrls = []) => {
  if (cancelTokenSource) {
    cancelTokenSource.cancel("Request canceled due to route change.");
  }
  cancelTokenSource = axios.CancelToken.source();

  // Attach a request interceptor to exclude specific URLs
  axiosIns.interceptors.request.use((config) => {
    if (excludeUrls.some((url) => config.url.includes(url))) {
      // Do not attach the cancel token for excluded URLs
      return config;
    }
    config.cancelToken = cancelTokenSource.token;
    return config;
  });

  axiosIns.defaults.cancelToken = cancelTokenSource.token;
};

Vue.prototype.$http = axiosIns;

export default axiosIns;
